import { computed, ComputedRef, reactive } from 'vue';

const state: IBasketButtonState = reactive({
    disabled: false,
});

export default function useProductPurchase() {
    const setBasketDisabledState = (newState: boolean): void => {
        state.disabled = newState;
    };

    const basketButtonIsDisabled: ComputedRef<boolean> = computed(() => state.disabled);

    return {
        setBasketDisabledState,
        basketButtonIsDisabled,
    };
}

export interface IBasketButtonState {
    disabled: boolean;
}
